// extracted by mini-css-extract-plugin
export default {"techList":"_TechList_techList__cpk-g"};